import React from "react";
import {
  Tab,
  Tabs,
  OverlayTrigger,
  Button,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import "./MentorProfile.scss";
import Profile from "./Profile";
import useMentorProfile from "./useMentorProfile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import Evaluation from "./Evaluation";
import { getRating } from "../../../_helpers/getRating";
import { pdfjs } from "react-pdf";

import CustomPdfViewer from "../../Common/CustomPdfViewer";
import { Footer } from "antd/es/layout/layout";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    userData,
    userPrimarySkills,
    onEditProfile,
    onUploadResume,
    loadingUploadResume,
  } = useMentorProfile(props);
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  return (
    <MainLayout pageName={"My Profile"}>
        <div className="py-2">
          <div className="container d-flex justify-content-between align-items-center">
            <h2 className="text-capitalize">
              {userData?.user_details && userData.user_details?.full_name}
            </h2>
          </div>
        </div>
        <div className="hiring-process-dashboard footer-gap w-100">
          <div className="hiring-board mt-3">
            <div className="container">
              <div className="row pr-1 no-gutters">
                <div className="candidate-info-sidebar bg-white border border-radius-10 col-lg-3">
                  <div className="p-3 ">
                    <div className="mb-2 w-100 d-flex align-items-center text-lg-center text-xl-left flex-lg-column flex-xl-row">
                      <div className="candidate-img mw-100 rounded-lg">
                        <img
                          src={
                            userData?.user_details &&
                              userData.user_details?.user_meta_info &&
                              userData.user_details.user_meta_info?.profile_image
                              ? userData?.user_details &&
                              userData.user_details?.user_meta_info &&
                              userData.user_details.user_meta_info
                                ?.profile_image
                              : " /assets/images/user.png"
                          }
                          alt="candidate img "
                          className="profile-image mr-3"
                        />
                      </div>
                      <div className="candidate-quick-info">
                        <h3 className="text-capitalize mx-auto pt-2">
                          {userData?.user_details &&
                            userData.user_details?.full_name}
                        </h3>
                        <p className="text-capitalize text-grey-4 pt-2">
                          {userData?.headline}
                        </p>
                      </div>
                    </div>
                    {Array.isArray(userData?.skills) &&
                      userData.skills.length !== 0 ? (
                      <span className="font-weight-medium my-3 d-inline-block bg-grey-3 rounded-pill pl-2 pr-1 py-1 border text-lg-center text-xl-left">
                        Overall Rating
                        <OverlayTrigger
                          overlay={<Tooltip>self evaluated skills</Tooltip>}
                        >
                          <Button
                            variant="white"
                            className="p-0 text-warning"
                          >
                            <span className="overall-rating p-2 rounded-pill custom-tag tag-offer ml-2">
                              <FontAwesomeIcon
                                icon={faStar}
                                className="mr-1"
                              />
                              <span className="text-danger fs-14">
                                {userData?.skills &&
                                  getRating(userData && userData?.skills)}
                              </span>
                            </span>
                          </Button>
                        </OverlayTrigger>
                      </span>
                    ) : null}
                    <div className="text-center py-2">
                      <button
                        className="btn btn-primary w-100"
                        onClick={onEditProfile}
                      >
                        Edit Profile
                      </button>
                    </div>
                  </div>

                  {/* evaluation list  */}
                  <div className="evaluation-list border-top pt-2 d-none d-lg-block">
                    {Array.isArray(userPrimarySkills) &&
                      userPrimarySkills.map((item) => (
                        <div className="" key={item?.id}>
                          {/* evaluation box  */}
                          <div className="evaluation-box py-3 px-2 bg-white rounded shadow-sm mb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="text-capitalize fs-14 bg-grey rounded px-1">
                                {item?.skill_name}
                              </p>
                              <span className="d-inline-block border rounded text-primary px-2">
                                <FontAwesomeIcon
                                  icon={faStar}
                                  className="mr-2 text-warning"
                                />
                                {item?.rating}
                              </span>
                            </div>
                            <ul className="d-flex evaluation-ratings align-items-center mt-3">
                              {item?.rating
                                ? [...Array(item?.rating).keys()].map(() => (
                                  <li className="bg-light">
                                    <span
                                      className="d-inline-block bg-primary h-100"
                                      style={{ width: "100%" }}
                                    ></span>
                                  </li>
                                ))
                                : null}
                              {[...Array(5 - item?.rating).keys()].map((i) => (
                                <li className="bg-light">
                                  <span
                                    className="d-inline-block bg-primary h-100"
                                    style={{ width: "0%" }}
                                  ></span>
                                </li>
                              ))}
                            </ul>
                          </div>

                          {/* evaluation box ends */}
                        </div>
                      ))}
                  </div>
                  {/* evaluation box ends */}
                </div>
                {/* applied applied info  */}
                <div className="col-lg-9">
                  <div className="panel-right pt-3">
                    <Tabs
                      defaultActiveKey="MentorProfile"
                      className="border-bottom ml-lg-4"
                    >
                      <Tab eventKey="MentorProfile" title="Mentor Profile">
                        <div className="tab-inner py-4 px-lg-4">
                          <Profile />
                        </div>
                      </Tab>
                      <Tab eventKey="Resume" title="Resume">
                        <div className="tab-inner  py-4 px-lg-4">
                          {userData?.user_details &&
                            userData.user_details?.user_meta_info &&
                            userData.user_details.user_meta_info?.resume ? (
                            <div className="bg-white border-radius-10 border p-3">
                              <div className="d-flex justify-content-end pb-3">
                                <label
                                  htmlFor="resumeUpload"
                                  className="btn btn-light d-flex align-items-center"
                                >
                                  {loadingUploadResume ? (
                                    <Spinner animation="border" role="status">
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  ) : (
                                    <>
                                      <img
                                        src="/assets/images/upload.svg"
                                        alt="download"
                                        className="mr-2"
                                      />
                                      Update Resume
                                    </>
                                  )}
                                  <input
                                    id="resumeUpload"
                                    className="h-auto d-none"
                                    type="file"
                                    name="resume"
                                    accept=".pdf"
                                    onChange={onUploadResume}
                                  />
                                </label>

                                <a
                                  href={
                                    userData?.user_details &&
                                    userData.user_details?.user_meta_info &&
                                    userData.user_details.user_meta_info?.resume
                                  }
                                  target="_blank"
                                  className="btn btn-light d-flex align-items-center ml-3"
                                >
                                  <img
                                    src="/assets/images/download.svg"
                                    alt="download"
                                    className="mr-2"
                                  />
                                  Download Resume
                                </a>
                              </div>

                              <CustomPdfViewer
                                file={
                                  userData?.user_details &&
                                  userData.user_details?.user_meta_info &&
                                  userData.user_details.user_meta_info?.resume
                                }
                              />
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center text-center">
                              <img
                                src="/assets/images/empty-resume.svg"
                                alt="no resume"
                                className="mb-3"
                              />
                              <h3 className="mb-2">No Resume Uploaded.</h3>
                              <p>
                                Upload your resume for hassle free job search
                              </p>
                              <label
                                htmlFor="resumeUpload"
                                className="text-primary bg-white font-weight-semi py-2 px-3 border border-primary text-center rounded-lg"
                              >
                                {loadingUploadResume ? (
                                  <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                  </Spinner>
                                ) : (
                                  "Upload Resume"
                                )}
                                <input
                                  id="resumeUpload"
                                  className="h-auto d-none"
                                  type="file"
                                  name="resume"
                                  accept=".pdf"
                                  onChange={onUploadResume}
                                />
                              </label>
                            </div>
                          )}
                        </div>
                      </Tab>
                      <Tab eventKey="Evaluation" title="Evaluation">
                        <div className="tab-inner py-4 px-lg-4">
                          <Evaluation
                            userPrimarySkills={userPrimarySkills}
                            overallRatings={
                              userData?.skills && getRating(userData?.skills)
                            }
                          />
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
    </MainLayout>
  );
};
